const FEATURE_NAME = 'me'

const loginUserQueryKeys = {
  index: () => [FEATURE_NAME, 'loginUser'] as const,
}

export default loginUserQueryKeys
